import img from '../assets/phoenix-logo.png';
import FC1 from '../assets/C3.png';
import FC2 from '../assets/C4.jpg';
import BAD from '../assets/BADM.png';
import LC1 from '../assets/LC3.png';
import LC2 from '../assets/LC4.png';

export const IMAGES = {
  img,
  FC1,
  FC2,
  BAD,
  LC1,
  LC2,
};

export const HolidayDates  = [
  '2025-12-04',
  '2025-12-25',
  '2026-01-03',
  '2026-01-15',
  '2026-02-01',
  '2026-02-04',
  '2026-02-15',
  '2026-03-02',
  '2026-03-21',
  '2026-04-01',
  '2026-04-03',
  '2026-04-13',
  '2026-04-14',
  '2026-05-01',
  '2026-05-02',
  '2026-05-28',
  '2026-05-30',
  '2026-06-29',
  '2026-07-29',
  '2026-08-26',
  '2026-08-27',
  '2026-09-26',
  '2026-10-25',
  '2026-11-08',
  '2026-11-24',
  '2026-12-23',
  '2026-12-25',
];
